import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

import Home from "./screen/Home";
import Hornsby from "./screen/Hornsby";
import Eastwood from "./screen/Eastwood";
const About = () => <div>About Page Content</div>;
const MainMenu = () => <div>Menu Page Content</div>;
const Reservation = () => <div>Reservation Page Content</div>;

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/hornsby" element={<Hornsby />} />
        <Route path="/eastwood" element={<Eastwood />} />
        <Route path="/Reservation" element={<Reservation />} />

        <Route path="*" element={<div>404 Page Not Found</div>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
